import Login from "./pages/login";
import './style/global.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Principal from './pages/principal';
import CadEmpresa from './pages/cadastro/empresa';
import CadUsuario from './pages/cadastro/usuario';
import CadProduto from './pages/cadastro/produto';
import OpePedido from './pages/operacoes/pedido';
import RelPedido from './pages/relatorio/relpedido';
import RelProducaoFuncionario from './pages/relatorio/relproducaofuncionario';
import { AppProvider } from './context/AppContext.js';

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/principal" element={<Principal />} />          
          <Route path="/cad/empresa" element={<CadEmpresa />} />  
          <Route path="/cad/usuario" element={<CadUsuario />} /> 
          <Route path="/cad/produto" element={<CadProduto />} /> 
          <Route path="/ope/pedido" element={<OpePedido />} /> 
          <Route path="/rel/pedido" element={<RelPedido />} /> 
          <Route path="/rel/producaofuncionario" element={<RelProducaoFuncionario />} /> 
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
